import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import FixturesIndex from "@/pages/FixturesIndex";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/fixtures/")({
  head: () => ({
    meta: [
      { title: "Football Fixtures & Predictions Archive | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["fixtures"] }).meta },
      { name: "description", content: "Browse every past and upcoming football fixture with predictions, odds and analysis. The full Statlign match archive, indexed for search engines and AI crawlers." },
      { property: "og:title", content: "Football Fixtures & Predictions Archive | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Browse every past and upcoming football fixture with predictions, odds and analysis. The full Statlign match archive, indexed for search engines and AI crawlers." },
      { name: "twitter:title", content: "Football Fixtures & Predictions Archive | Statlign" },
      { name: "twitter:description", content: "Browse every past and upcoming football fixture with predictions, odds and analysis. The full Statlign match archive, indexed for search engines and AI crawlers." },
    ],
  }),
  component: () => (
    <MainLayout>
      <FixturesIndex />
    </MainLayout>
  ),
});
